import parseEmojisAndHtml from 'core/libs/helpers/parseEmojisAndHtml';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Failed from 'theme/assets/images/project-failed.svg';
import Passed from 'theme/assets/images/project-passed.svg';
import ProjectSubmission from '../ProjectSubmission';

const ProjectFeedback = ({
  feedback,
  step,
  isSubmissionHistory,
  hasSubscription,
  trackId,
  partner,
  userId,
}) => {
  const generalFeedback = feedback && feedback[0];
  return (
    <div className="tr ph6-ns ph2 mt4-ns mt3">
      {generalFeedback ? (
        <>
          <div className="flex">
            {generalFeedback.status && (
              <img
                src={generalFeedback.status === 'passed' ? Passed : Failed}
                height="60"
                width="60"
                alt=""
              />
            )}
            <div>
              {generalFeedback.title && (
                <h3 className="ph3">{generalFeedback.title}</h3>
              )}
              {generalFeedback.description && (
                <div className="pa3">
                  <p className="flex">
                    {parseEmojisAndHtml(generalFeedback.description)}
                  </p>
                </div>
              )}
            </div>
          </div>
          {generalFeedback.status === 'failed' && !isSubmissionHistory && (
            <div>
              <ProjectSubmission
                hasSubscription={hasSubscription}
                deadline={step.project.deadline}
                description={step.project.description}
                projectId={step.project.id}
                projectFailed
                trackId={trackId}
                partner={partner}
                userId={userId}
              />
            </div>
          )}
        </>
      ) : (
        <div className="tc pv5">
          <p className="f5">
            <FormattedMessage id="there_is_no_review" />
          </p>
        </div>
      )}
    </div>
  );
};

ProjectFeedback.propTypes = {
  feedback: PropTypes.array.isRequired,
  step: PropTypes.object.isRequired,
  isSubmissionHistory: PropTypes.bool,
  hasSubscription: PropTypes.bool.isRequired,
  trackId: PropTypes.string.isRequired,
  partner: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

export default ProjectFeedback;
